import {combineReducers} from 'redux';

import userReducer from './reducers/userReducer';
import uiSlice from './reducers/uiSlice';
import mapMarkerSlice from './reducers/mapMarkerSlice';
import mmReducer from './reducers/mmReducer';
import rmReducer from './reducers/rmReducer';
import driverReducer from './reducers/driverReducer';
import editOrderReducer from './reducers/editOrderReducer';
import parcelReturnReducer from './reducers/parcelReturnReducer';
import ssmReducer from './reducers/ssmReducer'
import filterSlice from './reducers/filterSlice';
import commonReducer from './reducers/commonReducer';
import resendOrderReducer from './reducers/resendOrderSlice';
import hdReducer from './reducers/hdReducer';
import qtReducer from './reducers/qtReducer';
import srReducer from './reducers/srReducer';
import saReducer from './reducers/saReducer';
import batchManagementReducer from './reducers/batchManagementReducer';
import tosbReducer from './reducers/tosbReducer';
import hpmReducer from './reducers/hpmReducer';
import ddReducer from './reducers/ddReducer';
import scanReportReducer from './reducers/scanReportReducer';
import complaintReducer from './reducers/complaintReducer';
import edrrReducer from './reducers/edrrReducer';
import secondDeliveryReducer from './reducers/secondDeliveryReducer';
import utReducer from './reducers/utReducer';
import uploadExcelReducer from './reducers/uploadExcelReducer';
import localDeliveryReducer from './reducers/localDeliveryReducer';
import userManagementReducer from './reducers/userManagementReducer';
import dropOffReducer from './reducers/dropOffReducer';
import driverAppApprocalReducer from './reducers/driverAppApprovalReducer';
import resendOrdersReducer from './reducers/resendOrdersReducer';
import incidentManagementReducer from './reducers/incidentManagementReducer';
import driverPickupReducer from './reducers/driverPickupReducer';
import deliveryAreaReducer from './reducers/deliveryAreaReducer';
import wrongAddressReducer from './reducers/wrongAddressReducer';
import messageCenterReducer from './reducers/messageCenterReducer';
import orderExchangeReducer from './reducers/orderExchangeReducer';
import selfPickupReducer from './reducers/selfPickupReducer';
import sortingMachineManagementReducer from './reducers/sortingMachineManagementReducer';
import bbcOrderManagementReducer from './reducers/bbcOrderManagementReducer';

const rootReducer = combineReducers({
    user: userReducer,
    mapManagement: mmReducer,
    routeManagement: rmReducer,
    ui: uiSlice,
    mapMarker: mapMarkerSlice,
    driver: driverReducer,
    editOrder: editOrderReducer,
    parcelReturn: parcelReturnReducer,
    batchManagement: batchManagementReducer,
    filter: filterSlice,
    common: commonReducer,
    resendOrder: resendOrderReducer,
    secondDelivery: secondDeliveryReducer,
    storageScanManagement: ssmReducer,
    helpDesk: hdReducer,
    quickTransfer: qtReducer,
    srReducer: srReducer,
    saReducer: saReducer,
    tosbReducer: tosbReducer,
    hpmReducer: hpmReducer,
    ddReducer: ddReducer,
    scanReportReducer: scanReportReducer,
    complaintReducer: complaintReducer,
    edrrReducer: edrrReducer,
    updateToolbox: utReducer,
    uploadExcelManagement: uploadExcelReducer,
    localDeliveryReducer: localDeliveryReducer,
    userManagementReducer: userManagementReducer,
    servicePoint: dropOffReducer,
    driverAppApproval: driverAppApprocalReducer,
    resendOrdersReducer: resendOrdersReducer,
    incidentManagement: incidentManagementReducer,
    driverPickupReducer: driverPickupReducer,
    deliveryAreaReducer: deliveryAreaReducer,
    wrongAddressReducer: wrongAddressReducer,
    messageCenterReducer: messageCenterReducer,
    orderExchangeReducer: orderExchangeReducer,
    selfPickupReducer: selfPickupReducer,
    smmReducer: sortingMachineManagementReducer,
    bbcOrderManagementReducer: bbcOrderManagementReducer
});

export default rootReducer;
